import { SnackBarColorSet } from './actions';

export type Message = {
  id: string;
  message: string;
  colorSet?: SnackBarColorSet;
};

export type MessagesState = {
  snackbars: Message[];
};

export const MessageInitialState = { snackbars: [] };

export enum MESSAGE_TYPES {
  COPIED_TO_CLIPBOARD = 'Copied to clipboard',
}
